import { SOME_KIND_OF_BLUE } from '../theme/color';

export const overrides = {
    MuiAppBar: {
        colorPrimary: {
            backgroundColor: SOME_KIND_OF_BLUE
        }
    }
};
